import { useQuery } from '@tanstack/react-query';
import { AuthApi } from '@/entities/user/session';

const INTERVAL_TIME = 1000 * 60 * 3;

export function useKeepAlive(enabled: boolean = true, interval?: number) {
  useQuery({
    queryKey: ['keep-alive'],
    queryFn: () => AuthApi.keepAlive().then((res) => res.data),
    enabled,
    retry: false,
    refetchOnMount: false,
    notifyOnChangeProps: [],
    refetchOnWindowFocus: false,
    refetchIntervalInBackground: true,
    refetchInterval: interval || INTERVAL_TIME,
  });
}